import { render, staticRenderFns } from "./ViewDadosCadastrais.vue?vue&type=template&id=ee061250&scoped=true"
import script from "./ViewDadosCadastrais.vue?vue&type=script&lang=js"
export * from "./ViewDadosCadastrais.vue?vue&type=script&lang=js"
import style0 from "./ViewDadosCadastrais.vue?vue&type=style&index=0&id=ee061250&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee061250",
  null
  
)

export default component.exports